import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  private isMobile: boolean;
  private isTouchDevice: boolean;

  get isAndroid(): boolean {
    return this.isApp && this.platform.is('android');
  }

  get isApp(): boolean {
    return this.isMobile;
  }

  get isTouch(): boolean {
    return this.isTouchDevice;
  }

  constructor(private platform: Platform) {
    this.isMobile = !(this.platform.is('desktop') || this.platform.is('mobileweb'));

    try {
      document.createEvent('TouchEvent');
      this.isTouchDevice = true;
    } catch (error) {
      this.isTouchDevice = false;
    }
  }
}
